import userStore from './userStore'
import HotelHomestay from './HotelHomestay'
import Scenic from './Scenic'
import order from './order'
import Brand from './Brand'
const variate = {
  ...userStore,
  ...HotelHomestay,
  ...Scenic,
  ...order,
  ...Brand,
  /*用户认证状态*/
  verifyType: [
    { id: '0', name: '未认证' },
    { id: '1', name: '已认证' },
    { id: '2', name: '待审核' },
    { id: '', name: '全部' },
  ],
      /*销售职位*/
    position:[
        { id: '1', name: '销售总监' },
        { id: '2', name: '销售副总监' },
        { id: '3', name: '销售主管' },
        { id: '4', name: '销售经理' },
        { id: '5', name: '销售代表' },
        { id: '6', name: '店长' },
        { id: '7', name: '店助' },
        { id: '8', name: '运营经理' },
        { id: '9', name: '前厅经理' },
        { id: '10', name: '总经理' },
        { id: '11', name: '副总经理' },
        { id: '12', name: '前厅客服' },
    ],
    /*用户级别*/
  userLevel: [
    { id: '0', name: '全部' },
    // { id: '1', name: '集团' },
    { id: '2', name: '企业' },
    { id: '3', name: '销售' },
    { id: '4', name: '个人' },
  ],
  /*用户性别*/
  sex: [
    { id: '0', name: '未知' },
    { id: '1', name: '男' },
    { id: '2', name: '女' }
  ],
  /*用户签约类型*/
  contractType:[
    { id: '0', name: '未签约' },
    { id: '1', name: '已签约' },
    { id: '', name: '全部' },
  ],
  /**导游等级 */
  guideLevel: [
    { id: '0', name: '无' },
    { id: '1', name: '初级' },
    { id: '2', name: '中级' },
    { id: '3', name: '高级' },
    { id: '4', name: '特级' },
  ],
  /*用户微信绑定状态*/
  bindWechatType:[
    { id: '0', name: '未绑定' },
    { id: '1', name: '已绑定' },
    { id: '', name: '全部' },
  ],
  /*全局经验类型变量*/
  EXPTYPES: [
    {id: 1, name: "签到"},
    {id: 2, name: "订单发布"},
    {id: 3, name: "订单报价"},
    {id: 4, name: "订单完成"},
    {id: 5, name: "订单付款"},
    { id: 6, name: '添加房型' },
    { id: 7, name: '手机绑定' },
    { id: 8, name: '微信绑定' },
    { id: 9, name: '订单取消' },
    { id: 10, name: '发布订单' },
    { id: 11, name: '支付尾款' },
    { id: 12, name: '提现冻结' },
    { id: 13, name: '退款' },
    { id: 14, name: '提现(已打款)' },
    { id: 15, name: '已拒绝' },
    { id: 16, name: '签约独家' },
    { id: 17, name: '系统增加' },
    { id: 18, name: '系统减少' },
    { id: 19, name: '支付订金' },
    { id: 20, name: '续住付款' },
    { id: 21, name: '采购商返利' },
    { id: 22, name: '度假产品返利' },
    { id: 23, name: '发布房态' },
    { id: 24, name: '景区产品给门店返点' },
    { id: 91, name: '系统升级补偿' }
  ],
  /*订单支付类型*/
  orderPayType:[
    { id:7, name: '订金' },
    { id:8, name: '尾款' },
    { id:9, name: '续住' },
    { id:10, name: '订单付款' },
  ],
  /*支付渠道*/
  payChannel: [
    {id: '0', name: '全部'},
    {id: '1', name: '支付宝'},
    {id: '2', name: '微信'},
  ],
  /*支付类型*/
  payType: [
    { id: 'CREDIT', name: '信用卡' },
    { id: 'PCREDIT', name: '花呗' },
    { id: 'DEBIT', name: '借记卡' },
    { id: 'BALANCE', name: '余额' },
    { id: 'UNKOWN', name: '未知' }
  ],
    /*交易状态*/
  payTypeStatus: [
    { id: '', name: '全部' },
    { id: 'SUCCESS', name: '支付成功' },
    { id: 'REFUND', name: '转入退款' },
    { id: 'NOTPAY', name: '未支付' },
    { id: 'CLOSED', name: '已关闭' },
    { id: 'REVOKED', name: '已撤销' },
    { id: 'USERPAYING', name: '用户支付中' },
    { id: 'PAYERROR', name: '支付失败' },
  ],
  /*退款状态*/
  Refund: [
    { id: '', name: '全部' },
    { id: 'SUCCESS', name: '退款成功' },
    { id: 'CLOSED', name: '退款关闭' },
    { id: 'PROCESSING', name: '退款处理中' },
    { id: 'ABNORMAL', name: '退款异常' },
  ],
  /*退款方式*/
  payTypeWay: [
    { id: '1', name: '全额退款' },
    { id: '2', name: '部分退款' },
  ],
  /*微信反馈码*/
  wechatCode: [
    { id: 1, name: '通知成功' },
    { id: 41009, name: '未绑定微信' },
    { id: 43004, name: '已取消关注' },
    { id: 41001, name: '缺少access_token参数' },
    { id: 40003, name: '不合法的OpenID' },
    { id: 40001, name: 'access_token 无效' },
    { id: 40037, name: '模板id不相符' }
  ],
  /*价格区间*/
  priceLabel: [
    { id: 0, name: '不限' }, { id: 1, name: '150元以内' }, { id: 2, name: '151-300元' },
    { id: 3, name: '301-600元' }, { id: 4, name: '601-1000元' }, { id: 5, name: '1000元以上' }
  ],
  /*所属类型*/
  bankType: [
    { id: '1', name: '企业' }, { id: '2', name: '个人' },
  ],
   /* 经验等级*/
   expGrade:[
    { // 无
        grade: 1,    // 等级
        min: 0,      // 最小经验
        max: 199,    // 最大经验
        pic: 'grade_0.png' // 图标
    },
    { // 1心
        grade: 2,
        min: 200,
        max: 599,
        pic: 'grade_1.png'
    },
    { // 2心
        grade: 3,
        min: 600,
        max: 1199,
        pic: 'grade_2.png'
    },
    { // 1钻
        grade: 4,
        min: 1200,
        max: 2799,
        pic: 'grade_3.png'
    },
    { // 1钻1心
        grade: 5,
        min: 2800,
        max: 4799,
        pic: 'grade_4.png'
    },
    { // 1钻2心
        grade: 6,
        min: 4800,
        max: 7199,
        pic: 'grade_5.png'
    },
    { // 2钻
        grade: 7,
        min: 7200,
        max: 9999,
        pic: 'grade_6.png'
    },
    { // 2钻1心
        grade: 8,
        min: 10000,
        max: 13199,
        pic: 'grade_7.png'
    },
    { // 2钻2心
        grade: 9,
        min: 13200,
        max: 16799,
        pic: 'grade_8.png'
    },
    { // 皇冠
        grade: 10,
        min: 16800,
        max: 20799,
        pic: 'grade_9.png'
    },
    { // 1皇冠1心
        grade: 11,
        min: 20800,
        max: 25199,
        pic: 'grade_10.png'
    },
    { // 1皇冠2心
        grade: 12,
        min: 25200,
        max: 29999,
        pic: 'grade_11.png'
    },
    { // 1皇冠1钻
        grade: 13,
        min: 30000,
        max: 35199,
        pic: 'grade_12.png'
    },
    { // 1皇冠1钻1心
        grade: 14,
        min: 35200,
        max: 40799,
        pic: 'grade_13.png'
    },
    { // 1皇冠1钻2心
        grade: 15,
        min: 40800,
        max: 46799,
        pic: 'grade_14.png'
    },
    { // 1皇冠2钻
        grade: 16,
        min: 46800,
        max: 53199,
        pic: 'grade_15.png'
    },
    { // 1皇冠2钻1心
        grade: 17,
        min: 53200,
        max: 59999,
        pic: 'grade_16.png'
    },
    { // 1皇冠2钻2心
        grade: 18,
        min: 60000,
        max: 67199,
        pic: 'grade_17.png'
    },
    { // 2皇冠
        grade: 19,
        min: 67200,
        max: 74799,
        pic: 'grade_18.png'
    },
    { // 2皇冠1心
        grade: 20,
        min: 74800,
        max: 82799,
        pic: 'grade_19.png'
    },
    { // 2皇冠2心
        grade: 21,
        min: 82800,
        max: 91199,
        pic: 'grade_20.png'
    },
    { // 2皇冠1钻
        grade: 22,
        min: 91200,
        max: 999999,
        pic: 'grade_21.png'
    },
    { // 2皇冠1钻1心
        grade: 23,
        min: 100000,
        max: 109199,
        pic: 'grade_22.png'
    },
    { // 2皇冠1钻2心
        grade: 24,
        min: 109200,
        max: 118799,
        pic: 'grade_23.png'
    },
    { // 2皇冠2钻
        grade: 25,
        min: 118800,
        max: 128799,
        pic: 'grade_24.png'
    },
    { // 2皇冠2钻1心
        grade: 26,
        min: 128800,
        max: 139199,
        pic: 'grade_25.png'
    },
    { // 2皇冠2钻2心
        grade: 27,
        min: 139200,
        max: 149999,
        pic: 'grade_26.png'
    },
    { // 金冠
        grade: 28,
        min: 150000,
        max: 299999,
        pic: 'grade_27.png'
    },
    { // 金冠+
        grade: 29,
        min: 300000,
        max: 1000000000,
        pic: 'grade_27.png'
    }
    ],
  /*银行卡列表*/
  bankList: [
    {value:'CDB',text:'国家开发银行'},
    {value:'ICBC', text:'中国工商银行'},
    {value:'ABC',text:'中国农业银行'},
    {value:'BOC',text:'中国银行'},
    {value:'CCB',text:'中国建设银行'},
    {value:'PSBC',text:'中国邮政储蓄银行'},
    {value:'COMM',text:'交通银行'},
    {value:'CMB',text:'招商银行'},
    {value:'SPDB',text:'上海浦东发展银行'},
    {value:'CIB',text:'兴业银行'},
    {value:'HXBANK',text:'华夏银行'},
    {value:'GDB',text:'广东发展银行'},
    {value:'CMBC', text:'中国民生银行'},
    {value:'CITIC',text:'中信银行'},
    {value:'CEB',text:'中国光大银行'},
    {value:'EGBANK',text:'恒丰银行'},
    {value:'CZBANK',text:'浙商银行'},
    {value:'BOHAIB',text:'渤海银行'},
    {value:'SPABANK',text:'平安银行'},
    {value:'SHRCB',text:'上海农村商业银行'},
    {value:'YXCCB',text:'玉溪市商业银行'},
    {value:'YDRCB',text:'尧都农商行'},
    {value:'BJBANK',text:'北京银行'},
    {value:'SHBANK',text:'上海银行'},
    {value:'JSBANK',text:'江苏银行'},
    {value:'HZCB',text:'杭州银行'},
    {value:'NJCB',text:'南京银行'},
    {value:'NBBANK',text:'宁波银行'},
    {value:'HSBANK',text:'徽商银行'},
    {
          value:'CSCB',
          text:'长沙银行'
      },
      {
          value:'CDCB',
          text:'成都银行'
      },
      {
          value:'CQBANK',
          text:'重庆银行'
      },
      {
          value:'DLB',
          text:'大连银行'
      },
      {
          value:'NCB',
          text:'南昌银行'
      },
      {
          value:'FJHXBC',
          text:'福建海峡银行'
      },
      {
          value:'HKB',
          text:'汉口银行'
      },
      {
          value:'WZCB',
          text:'温州银行'
      },
      {
          value:'QDCCB',
          text:'青岛银行'
      },
      {
          value:'TZCB',
          text:'台州银行'
      },
      {
          value:'JXBANK',
          text:'嘉兴银行'
      },
      {
          value:'CSRCB',
          text:'常熟农村商业银行'
      },
      {
          value:'NHB',
          text:'南海农村信用联社'
      },
      {
          value:'CZRCB',
          text:'常州农村信用联社'
      },
      {
          value:'H3CB',
          text:'内蒙古银行'
      },
      {
          value:'SXCB',
          text:'绍兴银行'
      },
      {
          value:'SDEB',
          text:'顺德农商银行'
      },
      {
          value:'WJRCB',
          text:'吴江农商银行'
      },
      {
          value:'ZBCB',
          text:'齐商银行'
      },
      {
          value:'GYCB',
          text:'贵阳市商业银行'
      },
      {
          value:'ZYCBANK',
          text:'遵义市商业银行'
      },
      {
          value:'HZCCB',
          text:'湖州市商业银行'
      },
      {
          value:'DAQINGB',
          text:'龙江银行'
      },
      {
          value:'JINCHB',
          text:'晋城银行JCBANK'
      },
      {
          value:'ZJTLCB',
          text:'浙江泰隆商业银行'
      },
      {
          value:'GDRCC',
          text:'广东省农村信用社联合社'
      },
      {
          value:'DRCBCL',
          text:'东莞农村商业银行'
      },
      {
          value:'MTBANK',
          text:'浙江民泰商业银行'
      },
      {
          value:'GCB',
          text:'广州银行'
      },
      {
          value:'LYCB',
          text:'辽阳市商业银行'
      },
      {
          value:'JSRCU',
          text:'江苏省农村信用联合社'
      },
      {
          value:'LANGFB',
          text:'廊坊银行'
      },
      {
          value:'CZCB',
          text:'浙江稠州商业银行'
      },
      {
          value:'DYCB',
          text:'德阳商业银行'
      },
      {
          value:'JZBANK',
          text:'晋中市商业银行'
      },
      {
          value:'BOSZ',
          text:'苏州银行'
      },
      {
          value:'GLBANK',
          text:'桂林银行'
      },
      {
          value:'URMQCCB',
          text:'乌鲁木齐市商业银行'
      },
      {
          value:'CDRCB',
          text:'成都农商银行'
      },
      {
          value:'ZRCBANK',
          text:'张家港农村商业银行'
      },
      {
          value:'BOD',
          text:'东莞银行'
      },
      {
          value:'LSBANK',
          text:'莱商银行'
      },
      {
          value:'BJRCB',
          text:'北京农村商业银行'
      },
      {
          value:'TRCB',
          text:'天津农商银行'
      },
      {
          value:'SRBANK',
          text:'上饶银行'
      },
      {
          value:'FDB',
          text:'富滇银行'
      },
      {
          value:'CRCBANK',
          text:'重庆农村商业银行'
      },
      {
          value:'ASCB',
          text:'鞍山银行'
      },
      {
          value:'NXBANK',
          text:'宁夏银行'
      },
      {
          value:'BHB',
          text:'河北银行'
      },
      {
          value:'HRXJB',
          text:'华融湘江银行'
      },
      {
          value:'ZGCCB',
          text:'自贡市商业银行'
      },
      {
          value:'YNRCC',
          text:'云南省农村信用社'
      },
      {
          value:'JLBANK',
          text:'吉林银行'
      },
      {
          value:'DYCCB',
          text:'东营市商业银行'
      },
      {
          value:'KLB',
          text:'昆仑银行'
      },
      {
          value:'ORBANK',
          text:'鄂尔多斯银行'
      },
      {
          value:'XTB',
          text:'邢台银行'
      },
      {
          value:'JSB',
          text:'晋商银行'
      },
      {
          value:'TCCB',
          text:'天津银行'
      },
      {
          value:'BOYK',
          text:'营口银行'
      },
      {
          value:'JLRCU',
          text:'吉林农信'
      },
      {
          value:'SDRCU',
          text:'山东农信'
      },
      {
          value:'XABANK',
          text:'西安银行'
      },
      {
          value:'HBRCU',
          text:'河北省农村信用社'
      },
      {
          value:'NXRCU',
          text:'宁夏黄河农村商业银行'
      },
      {
          value:'GZRCU',
          text:'贵州省农村信用社'
      },
      {
          value:'FXCB',
          text:'阜新银行'
      },
      {
          value:'HBHSBANK',
          text:'湖北银行黄石分行'
      },
      {
          value:'ZJNX',
          text:'浙江省农村信用社联合社'
      },
      {
          value:'XXBANK',
          text:'新乡银行'
      },
      {
          value:'HBYCBANK',
          text:'湖北银行宜昌分行'
      },
      {
          value:'LSCCB',
          text:'乐山市商业银行'
      },
      {
          value:'TCRCB',
          text:'江苏太仓农村商业银行'
      },
      {
          value:'BZMD',
          text:'驻马店银行'
      },
      {
          value:'GZB',
          text:'赣州银行'
      },
      {
          value:'WRCB',
          text:'无锡农村商业银行'
      },
      {
          value:'BGB',
          text:'广西北部湾银行'
      },
      {
          value:'GRCB',
          text:'广州农商银行'
      },
      {
          value:'JRCB',
          text:'江苏江阴农村商业银行'
      },
      {
          value:'BOP',
          text:'平顶山银行'
      },
      {
          value:'TACCB',
          text:'泰安市商业银行'
      },
      {
          value:'CGNB',
          text:'南充市商业银行'
      },
      {
          value:'CCQTGB',
          text:'重庆三峡银行'
      },
      {
          value:'XLBANK',
          text:'中山小榄村镇银行'
      },
      {
          value:'HDBANK',
          text:'邯郸银行'
      },
      {
          value:'KORLABANK',
          text:'库尔勒市商业银行'
      },
      {
          value:'BOJZ',
          text:'锦州银行'
      },
      {
          value:'QLBANK',
          text:'齐鲁银行'
      },
      {
          value:'BOQH',
          text:'青海银行'
      },
      {
          value:'YQCCB',
          text:'阳泉银行'
      },
      {
          value:'SJBANK',
          text:'盛京银行'
      },
      {
          value:'FSCB',
          text:'抚顺银行'
      },
      {
          value:'ZZBANK',
          text:'郑州银行'
      },
      {
          value:'SRCB',
          text:'深圳农村商业银行'
      },
      {
          value:'BANKWF',
          text:'潍坊银行'
      },
      {
          value:'JJBANK',
          text:'九江银行'
      },
      {
          value:'JXRCU',
          text:'江西省农村信用'
      },
      {
          value:'HNRCU',
          text:'河南省农村信用'
      },
      {
          value:'GSRCU',
          text:'甘肃省农村信用'
      },
      {
          value:'SCRCU',
          text:'四川省农村信用'
      },
      {
          value:'GXRCU',
          text:'广西省农村信用'
      },
      {
          value:'SXRCCU',
          text:'陕西信合'
      },
      {
          value:'WHRCB',
          text:'武汉农村商业银行'
      },
      {
          value:'YBCCB',
          text:'宜宾市商业银行'
      },
      {
          value:'KSRB',
          text:'昆山农村商业银行'
      },
      {
          value:'SZSBK',
          text:'石嘴山银行'
      },
      {
          value:'HSBK',
          text:'衡水银行'
      },
      {
          value:'XYBANK',
          text:'信阳银行'
      },
      {
          value:'NBYZ',
          text:'鄞州银行'
      },
      {
          value:'ZJKCCB',
          text:'张家口市商业银行'
      },
      {
          value:'XCYH',
          text:'许昌银行'
      },
      {
          value:'JNBANK',
          text:'济宁银行'
      },
      {
          value:'CBKF',
          text:'开封市商业银行'
      },
      {
          value:'WHCCB',
          text:'威海市商业银行'
      },
      {
          value:'HBC',
          text:'湖北银行'
      },
      {
          value:'BOCD',
          text:'承德银行'
      },
      {
          value:'BODD',
          text:'丹东银行'
      },
      {
          value:'JHBANK',
          text:'金华银行'
      },
      {
          value:'BOCY',
          text:'朝阳银行'
      },
      {
          value:'LSBC',
          text:'临商银行'
      },
      {
          value:'BSB',
          text:'包商银行'
      },
      {
          value:'LZYH',
          text:'兰州银行'
      },
      {
          value:'BOZK',
          text:'周口银行'
      },
      {
          value:'DZBANK',
          text:'德州银行'
      },
      {
          value:'SCCB',
          text:'三门峡银行'
      },
      {
          value:'AYCB',
          text:'安阳银行'
      },
      {
          value:'ARCU',
          text:'安徽省农村信用社'
      },
      {
          value:'HURCB',
          text:'湖北省农村信用社'
      },
      {
          value:'HNRCC',
          text:'湖南省农村信用社'
      },
      {
          value:'NYNB',
          text:'广东南粤银行'
      },
      {
          value:'LYBANK',
          text:'洛阳银行'
      },
      {
          value:'NHQS',
          text:'农信银清算中心'
      },
      {
          value:'CBBQS',
          text:'城市商业银行资金清算中心'
      }
  ],
  /*用户注册来源*/
  traces: [
    { id: 0, name: '未知' },
    { id: 1, name: 'pc' },
    { id: 2, name: '微信h5' },
    { id: 3, name: '小程序' },
    { id: 4, name: 'IOS' },
    { id: 5, name: '安卓' },
    { id: 11, name: '用户添加子账号' },
    { id: 12, name: '管理员添加' }
  ],
};
export default variate;
